import useFreestarAdVastTag from 'hooks/useFreestarAdVastTag';

const useCamAdVastTag = (hasAdFreeCamPermissions: boolean, camId?: string) =>
  useFreestarAdVastTag(hasAdFreeCamPermissions, camId);

export default useCamAdVastTag;
